

// import React from 'react';
// import bikeImage1 from '../assets/Scooter.png';
// import bikeImage2 from '../assets/Electrical.png';
// import bikeImage3 from '../assets/Rx.png';
// import bikeImage4 from '../assets/SportsBike.png';

// const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];

// // Dummy JSON data for each bike
// const bikes = [
//     {
//         id: 1,
//         name: "Hero Glamour Xtec 125 cc",
//         price: 11753,
//         image: bikeImage1,
//         distanceIncluded: "1288 km",
//         excessRate: "₹ 3/km + GST",
//         isNew: true
//     },
//     {
//         id: 2,
//         name: "Honda Shine 125 cc",
//         price: 11000,
//         image: bikeImage2,
//         distanceIncluded: "1200 km",
//         excessRate: "₹ 2.5/km + GST",
//         isNew: false
//     },
//     {
//         id: 3,
//         name: "Yamaha FZ-X 150 cc",
//         price: 12500,
//         image: bikeImage3,
//         distanceIncluded: "1300 km",
//         excessRate: "₹ 3.2/km + GST",
//         isNew: true
//     },
//     {
//         id: 4,
//         name: "Bajaj Pulsar NS125",
//         price: 11800,
//         image: bikeImage4,
//         distanceIncluded: "1250 km",
//         excessRate: "₹ 3/km + GST",
//         isNew: false
//     },
//     {
//         id: 5,
//         name: "Suzuki Gixxer 150 cc",
//         price: 12200,
//         image: bikeImage1,
//         distanceIncluded: "1300 km",
//         excessRate: "₹ 3.5/km + GST",
//         isNew: true
//     },
//     {
//         id: 6,
//         name: "TVS Apache RTR 160",
//         price: 12000,
//         image: bikeImage2,
//         distanceIncluded: "1270 km",
//         excessRate: "₹ 3/km + GST",
//         isNew: false
//     },
//     {
//         id: 7,
//         name: "Royal Enfield Classic 350",
//         price: 14000,
//         image: bikeImage3,
//         distanceIncluded: "1500 km",
//         excessRate: "₹ 3.8/km + GST",
//         isNew: true
//     },
//     {
//         id: 8,
//         name: "KTM Duke 200",
//         price: 15000,
//         image: bikeImage4,
//         distanceIncluded: "1600 km",
//         excessRate: "₹ 4/km + GST",
//         isNew: false
//     }
// ];

// function FilterRelevance() {
//     return (
//         <div className="flex min-h-screen">
//             {/* Left part (Leave this blank) */}
//             <div className="w-1/5"></div>

//             {/* Middle and Right parts */}
//             <div className="w-3/4">
//                 {/* Sorting bar */}
//                 <div className="flex justify-end mb-6">
//                     <h2 className="text-lg font-semibold">Sort by:</h2>
//                     <div className="flex space-x-4 ml-4">
//                         <button className="text-blue-600">Relevance</button>
//                         <button className="text-blue-600">Price - Low to High</button>
//                         <button className="text-blue-600">Price - High to Low</button>
//                     </div>
//                 </div>

//                 {/* Main Bike Card */}
//                 <div className="w-1/2 mb-6">
//                     {bikes.slice(0, 1).map((bike) => (
//                         <div key={bike.id} className="relative border rounded-lg shadow-lg p-6 flex flex-col justify-between">
//                             {bike.isNew && (
//                                 <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                                     New
//                                 </span>
//                             )}

//                             <img src={bike.image} alt={bike.name} className="w-full mt-4 h-auto border" />
//                             <div className="mt-4">
//                                 <h2 className="text-xl font-semibold">{bike.name}</h2>
//                                 <p className="text-gray-600">{bike.distanceIncluded} included</p>
//                                 <p className="text-sm">(Excess {bike.excessRate})</p> <br />
//                             </div>

//                             <div className="bg-white p-1 border shadow-md rounded flex items-center space-x-2 h-[3rem] mb-4">
//                                 <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
//                                 <select className="flex-1 border rounded px-2 py-1 h-full text-sm">
//                                     {locations.map((location, i) => (
//                                         <option key={i} value={location}>
//                                             {location}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>

//                             <div className="flex justify-between items-center mt-0">
//                                 <span className="text-gray-700 font-semibold">Pay: ₹{bike.price}/Month</span>
//                                 <button className="bg-[#FF9630] text-white px-4 py-2 rounded">
//                                     Book Now
//                                 </button>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* Suggested Bikes Section */}
//                 <h2 className="text-lg font-semibold mb-4">Suggested Bikes</h2>
//                 <div className="grid grid-cols-2 gap-6">
//                     {bikes.slice(1).map((bike) => (
//                         <div key={bike.id} className="relative border rounded-lg shadow-lg p-6 flex flex-col justify-between">
//                             {bike.isNew && (
//                                 <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                                     New
//                                 </span>
//                             )}

//                             <img src={bike.image} alt={bike.name} className="w-full mt-4 h-auto border" />
//                             <div className="mt-4">
//                                 <h2 className="text-xl font-semibold">{bike.name}</h2>
//                                 <p className="text-gray-600">{bike.distanceIncluded} included</p>
//                                 <p className="text-sm">(Excess {bike.excessRate})</p> <br />
//                             </div>

//                             <div className="bg-white p-1 border shadow-md rounded flex items-center space-x-2 h-[3rem] mb-4">
//                                 <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
//                                 <select className="flex-1 border rounded px-2 py-1 h-full text-sm">
//                                     {locations.map((location, i) => (
//                                         <option key={i} value={location}>
//                                             {location}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>

//                             <div className="flex justify-between items-center mt-0">
//                                 <span className="text-gray-700 font-semibold">Pay: ₹{bike.price}/Month</span>
//                                 <button className="bg-[#FF9630] text-white px-4 py-2 rounded">
//                                     Book Now
//                                 </button>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default FilterRelevance;


// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import bikeImage1 from '../assets/Scooter.png';
// import bikeImage2 from '../assets/Electrical.png';
// import bikeImage3 from '../assets/Rx.png';
// import bikeImage4 from '../assets/SportsBike.png';
// import { MdLocationOn } from 'react-icons/md'; // Importing the map icon
// const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];

// const bikes = [
//     {
//         id: 1,
//         name: "Hero Glamour Xtec 125 cc",
//         price: 11753,
//         image: bikeImage1,
//         distanceIncluded: "1288 km",
//         excessRate: "₹ 3/km + GST",
//         isNew: true
//     },
//     {
//         id: 2,
//         name: "Honda Shine 125 cc",
//         price: 11000,
//         image: bikeImage2,
//         distanceIncluded: "1200 km",
//         excessRate: "₹ 2.5/km + GST",
//         isNew: false
//     },
//     {
//         id: 3,
//         name: "Yamaha FZ-X 150 cc",
//         price: 12500,
//         image: bikeImage3,
//         distanceIncluded: "1300 km",
//         excessRate: "₹ 3.2/km + GST",
//         isNew: true
//     },
//     {
//         id: 4,
//         name: "Bajaj Pulsar NS125",
//         price: 11800,
//         image: bikeImage4,
//         distanceIncluded: "1250 km",
//         excessRate: "₹ 3/km + GST",
//         isNew: false
//     },
//     {
//         id: 5,
//         name: "Suzuki Gixxer 150 cc",
//         price: 12200,
//         image: bikeImage1,
//         distanceIncluded: "1300 km",
//         excessRate: "₹ 3.5/km + GST",
//         isNew: true
//     },
//     {
//         id: 6,
//         name: "TVS Apache RTR 160",
//         price: 12000,
//         image: bikeImage2,
//         distanceIncluded: "1270 km",
//         excessRate: "₹ 3/km + GST",
//         isNew: false
//     },
//     {
//         id: 7,
//         name: "Royal Enfield Classic 350",
//         price: 14000,
//         image: bikeImage3,
//         distanceIncluded: "1500 km",
//         excessRate: "₹ 3.8/km + GST",
//         isNew: true
//     },
//     {
//         id: 8,
//         name: "KTM Duke 200",
//         price: 15000,
//         image: bikeImage4,
//         distanceIncluded: "1600 km",
//         excessRate: "₹ 4/km + GST",
//         isNew: false
//     },
//     {
//         id: 5,
//         name: "Suzuki Gixxer 150 cc",
//         price: 12200,
//         image: bikeImage1,
//         distanceIncluded: "1300 km",
//         excessRate: "₹ 3.5/km + GST",
//         isNew: true
//     },
//     {
//         id: 6,
//         name: "TVS Apache RTR 160",
//         price: 12000,
//         image: bikeImage2,
//         distanceIncluded: "1270 km",
//         excessRate: "₹ 3/km + GST",
//         isNew: false
//     },
// ];

// function FilterRelevance() {
//     const navigate = useNavigate();

//     const handleBookNow = (bikeId) => {
//         // navigate(`/accesories-component/${bikeId}`); // Redirect to a dynamic route based on bike ID
//         navigate('/accesories-component'); // Redirect to a dynamic route based on bike ID
//     };

//     return (
//         <div className="flex min-h-screen ">
//             <div className="w-full">
//                 {/* Sorting Bar */}
//                 <div className="flex justify-end mb-6">
//                     <h2 className="text-lg font-semibold">Sort by:</h2>
//                     <div className="flex space-x-4 ml-4">
//                         <button className="text-blue-600">Relevance</button>
//                         <button className="text-blue-600">Price - Low to High</button>
//                         <button className="text-blue-600">Price - High to Low</button>
//                     </div>
//                 </div>

//                 {/* Main Bike Card */}
//                 <div className="w-2/5 h-auto mb-6">
//                     {bikes.slice(0, 1).map((bike) => (
//                         <div key={bike.id} className="relative border rounded-lg shadow-lg p-6 flex flex-col justify-between">
//                             {bike.isNew && (
//                                 <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                                     New
//                                 </span>
//                             )}
//                             <img src={bike.image} alt={bike.name} className="w-full mt-4 h-auto border" />
//                             <div className="mt-4">
//                                 <h2 className="text-xl font-semibold text-center">{bike.name}</h2>
//                                 <p className="text-gray-600">{bike.distanceIncluded} included</p>

//                                 <p className="text-sm">(Excess {bike.excessRate})</p> <br />
//                             </div>
//                             <div className="bg-white p-1 border shadow-md rounded flex items-center space-x-2 h-[3rem] mb-4">
//                                 <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
//                                 <select className="flex-1 border rounded px-2 py-1 h-full text-sm">
//                                     {locations.map((location, i) => (
//                                         <option key={i} value={location}>
//                                             {location}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                             <div className="flex justify-between items-center mt-0">
//                                 <span className="text-gray-700 font-semibold">Pay: ₹{bike.price}/Month</span>
//                                 <button
//                                     className="bg-[#FF9630] text-white px-4 py-2 rounded"
//                                     onClick={() => handleBookNow(bike.id)}
//                                 >
//                                     Book Now
//                                 </button>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* Suggested Bikes Section */}
//                 <h2 className="text-lg font-semibold mb-4 ">Suggested Bikes</h2>
//                 <div className="grid grid-cols-3 gap-4">
//                     {bikes.slice(1).map((bike) => (
//                         <div key={bike.id} className="relative border rounded-lg shadow-lg p-6 flex flex-col justify-between">
//                             {bike.isNew && (
//                                 <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                                     New
//                                 </span>
//                             )}
//                             <img src={bike.image} alt={bike.name} className="w-full mt-4 h-auto border" />
//                            <div className="mt-4">
//                                 <h2 className="text-xl font-semibold">{bike.name}</h2>
//                                 <p className="text-gray-600">{bike.distanceIncluded} included</p>
//                                 <p className="text-sm">(Excess {bike.excessRate})</p> <br />

//                             </div> 

//                             <div className="mt-4">
//                                 <h2 className="text-lg text-center font-semibold">{bike.title}</h2>

//                                 {/* Line with the map icon */}
//                                 <div className="flex items-center text-gray-600 mt-4">
//                                     {/* Map icon */}
//                                     <p className="text-gray-600 text-left ">{bike.description}</p>
//                                 </div>
//                                 <p className="text-sm text-left pl-6 ">{bike.excess} </p>
//                             </div>



//                             <div className="bg-white p-1 border shadow-md rounded flex items-center space-x-2 h-[3rem] mb-4">
//                                 <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
//                                 <select className="flex-1 border rounded px-2 py-1 h-full text-sm">
//                                     {locations.map((location, i) => (
//                                         <option key={i} value={location}>
//                                             {location}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>
//                             <div className="flex justify-between items-center mt-0">
//                                 <span className="text-gray-700 font-semibold">Pay: ₹{bike.price}/Month</span>
//                                 <button
//                                     className="bg-[#FF9630] text-white px-4 py-2 rounded"
//                                     onClick={() => handleBookNow(bike.id)}
//                                 >
//                                     Book Now
//                                 </button>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default FilterRelevance;




// import React from 'react';
// import { MdLocationOn } from 'react-icons/md'; // Importing the map icon
// import { useNavigate } from 'react-router-dom'; // Import useNavigate
// const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];
// const bikeData =
//     [
//         {
//             "id": 1,
//             "title": "Hero Glamour Xtec 125 cc",
//             "image": "Scooter.png",
//             "description": "1288 km included",
//             "excess": "₹ 3/km + GST",
//             "location": "Bangalore",
//             "price": "₹11753/Month"
//         },
//         {
//             "id": 2,
//             "title": "Hero Glamour Xtec 125 cc",
//             "image": "Electrical.png",
//             "description": "1500 km included",
//             "excess": "₹ 5/km + GST",
//             "location": "Delhi",
//             "price": "₹12000/Month"
//         },
//         {
//             "id": 3,
//             "title": "RX 100 120cc",
//             "image": "Rx.png",
//             "description": "1000 km included",
//             "excess": "₹ 4/km + GST",
//             "location": "Mumbai",
//             "price": "₹9000/Month"
//         },
//         {
//             "id": 4,
//             "title": "Sports Bike 150 cc",
//             "image": "SportsBike.png",
//             "description": "2000 km included",
//             "excess": "₹ 6/km + GST",
//             "location": "Chennai",
//             "price": "₹15000/Month"
//         },
//         {
//             "id": 5,
//             "title": "Hero Glamour Xtec 125 cc",
//             "image": "Scooter.png",
//             "description": "1200 km included",
//             "excess": "₹ 3/km + GST",
//             "location": "Hyderabad",
//             "price": "₹11000/Month"
//         },
//         {
//             "id": 6,
//             "title": "Hero Glamour Xtec 125 cc",
//             "image": "Electrical.png",
//             "description": "1500 km included",
//             "excess": "₹ 4/km + GST",
//             "location": "Bangalore",
//             "price": "₹11500/Month"
//         },
//         {
//             "id": 7,
//             "title": "RX 100 120cc",
//             "image": "Rx.png",
//             "description": "900 km included",
//             "excess": "₹ 5/km + GST",
//             "location": "Delhi",
//             "price": "₹9500/Month"
//         },
//         {
//             "id": 8,
//             "title": "Sports Bike 150 cc",
//             "image": "SportsBike.png",
//             "description": "1800 km included",
//             "excess": "₹ 7/km + GST",
//             "location": "Mumbai",
//             "price": "₹16000/Month"
//         },
//         {
//             "id": 9,
//             "title": "Sports Bike 150 cc",
//             "image": "SportsBike.png",
//             "description": "1800 km included",
//             "excess": "₹ 7/km + GST",
//             "location": "Mumbai",
//             "price": "₹16000/Month"
//         }
//     ]

// function FilterRelevance() {
//     const navigate = useNavigate(); // Initialize the useNavigate hook

//     // Function to handle Book Now button click
//     const handleBookNow = (bikeId) => {
//         navigate('/accesories-component'); // Redirect to the booking page with bikeId
        
//     };
//     return (
//         <div className="flex min-h-screen p-4">
//             <div className="w-full">

//                 <div className="flex mb-6">
//                     <h2 className="text-lg font-semibold">Sort by:</h2>
//                     <div className="flex space-x-4 ml-4">
//                         <button className="text-gray-400 ">Relevance</button>
//                         <button className="text-gray-400">Price - Low to High</button>
//                         <button className="text-gray-400">Price - High to Low</button>
//                     </div>
//                 </div>
//                 {/* Main Bike Card */}

//                 <div className="w-full md:w-2/5  h-auto mb-6">
//                     {bikeData.slice(0, 1).map((bike) => (
//                         <div key={bike.id} className="relative border rounded-lg shadow-lg p-6 flex flex-col justify-between">
//                             {bike.isNew && (
//                                 <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                                     New
//                                 </span>
//                             )}

//                             <img
//                                 src={require(`../assets/${bike.image}`)} // Dynamically loading image
//                                 alt={bike.title}
//                                 className="w-full mt-4 h-auto border rounded-md"
//                             />
//                             <div className="mt-4">
//                                 <h2 className="text-lg text-center font-semibold">{bike.title}</h2>
//                                 {/* Line with the map icon */}
//                                 <div className="flex items-center text-gray-600 mt-4">
//                                     <MdLocationOn className="text-xl mr-1 text-red-500" /> {/* Map icon */}
//                                     <p className="text-gray-600 text-left ">{bike.description}</p>
//                                 </div>
//                                 <p className="text-sm text-left pl-6 ">{bike.excess} </p>
//                             </div>
//                             <div className='border-t' >
//                                 <div className="bg-white p-1 border rounded flex items-center space-x-2 h-auto mt-4">
//                                     <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
//                                     <select className="flex-1 rounded px-2 py-1 h-full text-sm">
//                                         {locations.map((location, i) => (
//                                             <option key={i} value={location}>
//                                                 {location}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="flex justify-between items-center  p-3">
//                                 <span className="text-gray-700 font-semibold">Pay: {bike.price}</span>
//                                 <button
//                                     className="bg-[#FF9630] text-white px-4 py-2 rounded"
//                                     onClick={() => handleBookNow(bike.id)} // Call the navigation function
//                                 >
//                                     Book Now
//                                 </button>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* Grid layout */}
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                     {/* Render 8 blocks from the JSON data */}
//                     {bikeData.map((bike, index) => (
//                         <div key={bike.id} className="relative border rounded-md shadow-lg  flex flex-col justify-between">
//                             {/* New label at the top left corner */}
//                             <div className='p-6 '>
//                                 <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                                     New
//                                 </span>

//                                 {/* Display different images */}
//                                 <img
//                                     src={require(`../assets/${bike.image}`)} // Dynamically loading image
//                                     alt={bike.title}
//                                     className="w-full mt-4 h-auto border rounded-md"
//                                 />


//                                 <div className="mt-4">
//                                     <h2 className="text-lg text-center font-semibold">{bike.title}</h2>
//                                     {/* Line with the map icon */}
//                                     <div className="flex items-center text-gray-600 mt-4">
//                                         <MdLocationOn className="text-xl mr-1 text-red-500" /> {/* Map icon */}
//                                         <p className="text-gray-600 text-left ">{bike.description}</p>
//                                     </div>
//                                     <p className="text-sm text-left pl-6 ">{bike.excess} </p>
//                                 </div>

//                                 {/* Location bar */}
//                             </div>
//                             <div className='border-t px-4'>
//                                 <div className="bg-white p-1 border  rounded flex items-center space-x-2 h-auto mb-4 mt-3 ">
//                                     <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
//                                     <select className="flex-1 rounded px-2 py-1 h-full text-sm">
//                                         {locations.map((location, i) => (
//                                             <option key={i} value={location}>
//                                                 {location}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Price and Book button */}
//                             <div className="flex justify-between items-center  p-3">
//                                 <span className="text-gray-700 font-semibold">Pay: {bike.price}</span>
//                                 <button className="bg-[#FF9630] text-white px-4 py-2 rounded">
//                                     Book Now
//                                 </button>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default FilterRelevance;

import React from 'react';
import { MdLocationOn } from 'react-icons/md'; // Importing the map icon
import { useNavigate } from 'react-router-dom'; // Import useNavigate
const locations = ["Bangalore", "Delhi", "Mumbai", "Chennai", "Hyderabad"];
const bikeData = [
    {
        "id": 1,
        "title": "Hero Glamour Xtec 125 cc",
        "image": "Scooter.png",
        "description": "1288 km included",
        "excess": "₹ 3/km + GST",
        "location": "Bangalore",
        "price": "₹11753/Month"
    },
    {
        "id": 2,
        "title": "Hero Glamour Xtec 125 cc",
        "image": "Electrical.png",
        "description": "1500 km included",
        "excess": "₹ 5/km + GST",
        "location": "Delhi",
        "price": "₹12000/Month"
    },
    {
        "id": 3,
        "title": "RX 100 120cc",
        "image": "Rx.png",
        "description": "1000 km included",
        "excess": "₹ 4/km + GST",
        "location": "Mumbai",
        "price": "₹9000/Month"
    },
    {
        "id": 4,
        "title": "Sports Bike 150 cc",
        "image": "SportsBike.png",
        "description": "2000 km included",
        "excess": "₹ 6/km + GST",
        "location": "Chennai",
        "price": "₹15000/Month"
    },
    {
        "id": 5,
        "title": "Hero Glamour Xtec 125 cc",
        "image": "Scooter.png",
        "description": "1200 km included",
        "excess": "₹ 3/km + GST",
        "location": "Hyderabad",
        "price": "₹11000/Month"
    },
    {
        "id": 6,
        "title": "Hero Glamour Xtec 125 cc",
        "image": "Electrical.png",
        "description": "1500 km included",
        "excess": "₹ 4/km + GST",
        "location": "Bangalore",
        "price": "₹11500/Month"
    },
    {
        "id": 7,
        "title": "RX 100 120cc",
        "image": "Rx.png",
        "description": "900 km included",
        "excess": "₹ 5/km + GST",
        "location": "Delhi",
        "price": "₹9500/Month"
    },
    {
        "id": 8,
        "title": "Sports Bike 150 cc",
        "image": "SportsBike.png",
        "description": "1800 km included",
        "excess": "₹ 7/km + GST",
        "location": "Mumbai",
        "price": "₹16000/Month"
    },
    {
        "id": 9,
        "title": "Sports Bike 150 cc",
        "image": "SportsBike.png",
        "description": "1800 km included",
        "excess": "₹ 7/km + GST",
        "location": "Mumbai",
        "price": "₹16000/Month"
    }
];

function FilterRelevance() {
    const navigate = useNavigate(); // Initialize the useNavigate hook

    // Function to handle Book Now button click
    const handleBookNow = (bikeId) => {
        // Check if the device is mobile, and navigate accordingly
        if (window.innerWidth <= 768) {
            // For mobile view, navigate to the accessories page
            navigate('/accesories');
        } else {
            // For desktop view, you can log the bike ID or take any other action
            navigate('/accesories-component'); 
        }
    };

    return (
        <div className="flex min-h-screen p-4">
            <div className="w-full">
                <div className="flex mb-6">
                    <h2 className="text-lg font-semibold">Sort by:</h2>
                    <div className="flex space-x-4 ml-4">
                        <button className="text-gray-400 ">Relevance</button>
                        <button className="text-gray-400">Price - Low to High</button>
                        <button className="text-gray-400">Price - High to Low</button>
                    </div>
                </div>

                {/* Main Bike Card */}
                <div className="w-full md:w-2/5  h-auto mb-6">
                    {bikeData.slice(0, 1).map((bike) => (
                        <div key={bike.id} className="relative border rounded-lg shadow-lg p-6 flex flex-col justify-between">
                            {bike.isNew && (
                                <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
                                    New
                                </span>
                            )}

                            <img
                                src={require(`../assets/${bike.image}`)} // Dynamically loading image
                                alt={bike.title}
                                className="w-full mt-4 h-auto border rounded-md"
                            />
                            <div className="mt-4">
                                <h2 className="text-lg text-center font-semibold">{bike.title}</h2>
                                <div className="flex items-center text-gray-600 mt-4">
                                    <MdLocationOn className="text-xl mr-1 text-red-500" />
                                    <p className="text-gray-600 text-left ">{bike.description}</p>
                                </div>
                                <p className="text-sm text-left pl-6 ">{bike.excess} </p>
                            </div>
                            <div className='border-t'>
                                <div className="bg-white p-1 border rounded flex items-center space-x-2 h-auto mt-4">
                                    <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
                                    <select className="flex-1 rounded px-2 py-1 h-full text-sm">
                                        {locations.map((location, i) => (
                                            <option key={i} value={location}>
                                                {location}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="flex justify-between items-center  p-3">
                                <span className="text-gray-700 font-semibold">Pay: {bike.price}</span>
                                <button
                                    className="bg-[#FF9630] text-white px-4 py-2 rounded"
                                    onClick={() => handleBookNow(bike.id)} // Call the navigation function
                                >
                                    Book Now
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Grid layout */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {bikeData.map((bike) => (
                        <div key={bike.id} className="relative border rounded-md shadow-lg flex flex-col justify-between">
                            <div className='p-6'>
                                <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
                                    New
                                </span>

                                <img
                                    src={require(`../assets/${bike.image}`)} // Dynamically loading image
                                    alt={bike.title}
                                    className="w-full mt-4 h-auto border rounded-md"
                                />

                                <div className="mt-4">
                                    <h2 className="text-lg text-center font-semibold">{bike.title}</h2>
                                    <div className="flex items-center text-gray-600 mt-4">
                                        <MdLocationOn className="text-xl mr-1 text-red-500" />
                                        <p className="text-gray-600 text-left ">{bike.description}</p>
                                    </div>
                                    <p className="text-sm text-left pl-6 ">{bike.excess} </p>
                                </div>
                            </div>
                            <div className='border-t px-4'>
                                <div className="bg-white p-1 border rounded flex items-center space-x-2 h-auto mb-4 mt-3">
                                    <p className="font-semibold text-sm whitespace-nowrap">Location:</p>
                                    <select className="flex-1 rounded px-2 py-1 h-full text-sm">
                                        {locations.map((location, i) => (
                                            <option key={i} value={location}>
                                                {location}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="flex justify-between items-center p-3">
                                <span className="text-gray-700 font-semibold">Pay: {bike.price}</span>
                                <button
                                    className="bg-[#FF9630] text-white px-4 py-2 rounded"
                                    onClick={() => handleBookNow(bike.id)} // Call the navigation function
                                >
                                    Book Now
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default FilterRelevance;
